<div class="promote">
    <div class="title centered-container" *ngIf="loading">
        <h2>Promoting</h2>
    </div>
    <div class="promote-finished" *ngIf="!loading">
        <div class="title centered-container">
            <h2>Project Promoted Successfully</h2>
            <button class="icon inline" title="Help" (click)="toggleHelp()">
                <span class="icon icon-ui-question"></span>
            </button>
        </div>
        <div class="centered-container">
            <div class="help" *ngIf="showHelp">
                <button class="icon inline close" (click)="toggleHelp()">
                    <span class="icon icon-ui-help"></span>
                </button>
                <h3>You're done!</h3>
                <p>Your gemometry data has been promoted to the "Live" tables.</p>
                <p>Feel free to use a mapping application to view your data on a map or create a new project.</p>
            </div>
        </div>
        <div class="centered-container" *ngIf="projectHasPromoteResults">
            <div class="results-stats">
                <div>
                    <div><label>Project Id:</label> {{ service.project.id }}</div>
                    <div><label>Project Description:</label> {{ service.project.description }}</div>
                    <div><label>Lifespan:</label> {{ service.project.lifeSpanDays }} days</div>
                </div>
                <table class="table">
                    <tbody>
                        <tr>
                            <td>Production Points</td>
                            <td><span class="label label-success">{{ service.project.pointCount }}</span></td>
                        </tr>
                        <tr>
                            <td>Production Lines</td>
                            <td><span class="label label-success">{{ service.project.lineCount }}</span></td>
                        </tr>
                        <tr *ngIf="project.promoteReport">
                            <td>Errors</td>
                            <td><span class="label label-danger">{{ service.errorCount }}</span></td>
                        </tr>
                    </tbody>
                </table>
                <div class="show-issues-link centered-container"
                    *ngIf="service.project && service.project.promoteReport">
                    <button class="btn red" (click)="toggleShowIssues()"
                        [disabled]="service.project.promoteReport.scenarios[0].errors.length === 0">
                        <span class="icon icon-ui-grid"></span>
                        <span *ngIf="!showIssues">Show</span>
                        <span *ngIf="showIssues">Hide</span>
                        Error Details
                    </button>
                </div>
            </div>
        </div>
        <div class="centered-container" *ngIf="showIssues && service.project && service.project.promoteReport">
            <div class="issues" *ngFor="let scenario of service.project.promoteReport.scenarios">
                <table class="table table-bordered">
                    <thead>
                        <th class="row-number" (click)="service.sortIndex = 0">Row</th>
                        <th (click)="sortIndex = 1">Error Message</th>
                    </thead>
                    <tr *ngFor="let promoteError of scenario.errors">
                        <td class="row-number">{{ promoteError.recordNumber }}</td>
                        <td>
                            {{ promoteError.message }}
                        </td>
                    </tr>
                </table>
            </div>
        </div>
        <div class="button-container">
            <button type="button" class="btn btn-cancel" (click)="service.close()">
                <span class="icon icon-ui-close"></span>
                Close PETL</button>
            <button type="button" class="btn btn-primary" (click)="service.startOver()">
                <span class="icon icon-ui-refresh"></span>
                Start a New File</button>
        </div>
    </div>
</div>